import { createRouteRef, createApiRef, createPlugin, createApiFactory, discoveryApiRef, identityApiRef, createRoutableExtension } from '@backstage/core-plugin-api';
import * as cheerio from 'cheerio';

const rootRouteRef = createRouteRef({
  id: "tech-updates"
});

const pluginConfig = {
  pluginId: "tech-updates"
};

const TechUpdatesApiRef = createApiRef({
  id: `plugin.${pluginConfig.pluginId}.service`
});

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class TechUpdatesClient {
  constructor({
    discoveryApi,
    identityApi
  }) {
    __publicField(this, "discoveryApi");
    __publicField(this, "identityApi");
    this.discoveryApi = discoveryApi;
    this.identityApi = identityApi;
  }
  async callApi(path, _query, options) {
    var _a;
    const apiUrl = await this.discoveryApi.getBaseUrl("proxy");
    const { token } = await this.identityApi.getCredentials();
    const response = await fetch(`${apiUrl}/${path}`, {
      method: (_a = options == null ? void 0 : options.method) != null ? _a : "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error(
        `Request failed for ${path}, ${response.status} ${response.statusText}`
      );
    }
    return response.text();
  }
  async listTechUpdates(numOfSections) {
    const result = await this.callApi(`tech-updates/`, {});
    const sections = [];
    const $ = cheerio.load(result);
    $(".publisher-block").each((_index, element) => {
      const publisherText = $(element).find(".publisher-text");
      const title = publisherText.find(".title .primary").text();
      const links = [];
      $(element).find(".publisher-link a").each((_i, el) => {
        const link = $(el).attr("href");
        const linkTitle = $(el).text();
        links.push({
          title: linkTitle,
          link: link || "#"
        });
      });
      const publisherInfo = {
        title,
        links: links.filter(Boolean)
      };
      sections.push(publisherInfo);
    });
    if (numOfSections) {
      return sections.slice(0, numOfSections);
    }
    return sections;
  }
}

const techUpdatesPlugin = createPlugin({
  id: pluginConfig.pluginId,
  apis: [
    createApiFactory({
      api: TechUpdatesApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) => new TechUpdatesClient({ discoveryApi, identityApi })
    })
  ],
  routes: {
    root: rootRouteRef
  }
});
const TechUpdatesPage = techUpdatesPlugin.provide(
  createRoutableExtension({
    name: "TechUpdatesPage",
    component: () => import('./index-fe50a1eb.esm.js').then((m) => m.TechUpdatesPage),
    mountPoint: rootRouteRef
  })
);
const TechUpdatesSections = techUpdatesPlugin.provide(
  createRoutableExtension({
    name: "TechUpdatesSections",
    component: () => import('./index-2b95a52f.esm.js').then(
      (m) => m.TechUpdatesSections
    ),
    mountPoint: rootRouteRef
  })
);

export { TechUpdatesApiRef as T, TechUpdatesPage as a, TechUpdatesSections as b, techUpdatesPlugin as t };
//# sourceMappingURL=index-2cff72b1.esm.js.map
